/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendBusinessAngelLoanDto } from '../../models/backend-business-angel-loan-dto';
import { BackendBusinessAngelLoanRequestDto } from '../../models/backend-business-angel-loan-request-dto';

export interface VentureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded$Params {
  body: BackendBusinessAngelLoanRequestDto;
}

export function ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendBusinessAngelLoanDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendBusinessAngelLoanDto>;
    }),
  );
}

ventureFundsBusinessAngelLoansCreate$XWwwFormUrlencoded.PATH = '/api/venture_funds/business-angel-loans/';
